import React, { useState } from 'react';
import {
	StyledCarousel,
	Dots,
	ArrowButton,
	BanksyImageMobile,
	BanksyImageDesktop,
} from './Carousel.styles';
import {
	Box,
	Flex,
	ChevronLeftIcon,
	ChevronRightIcon,
	ThemeProvider,
} from '@stashinvest/ui';
import { Text } from '@stashinvest/ui/dist/es/2';
import PropTypes from 'prop-types';

export const Carousel = ({ slides, sendSlideInfo, currentSlideInfo }) => {
	const [carousel, setCarousel] = useState(null);

	const carouselSettings = {
		autoplay: false,
		accessibility: false,
		adaptiveHeight: false,
		infinite: false,
		slidesToShow: 1,
		rows: 1,
		dots: false,
		speed: 300,
		arrows: false,
	};

	return (
		<>
			<StyledCarousel
				{...carouselSettings}
				ref={setCarousel}
				beforeChange={(index, nextIndex) => {
					sendSlideInfo({
						slideName: slides[nextIndex].slideName,
						slideNumber: nextIndex + 1,
					});
				}}
			>
				{slides.map((item, index) => (
					<Box key={index} p={{ tablet: 's' }} px={{ mobile: 's' }}>
						{index === 0 ? (
							<ThemeProvider mode="light">
								<BanksyImageDesktop src={item.img} alt="Stash logo" />
								<BanksyImageMobile src={item.mobileImg} alt="Stash logo" />
							</ThemeProvider>
						) : (
							<>
								<BanksyImageDesktop src={item.img} alt="Stash logo" />
								<BanksyImageMobile mx="auto" src={item.mobileImg} alt="Stash logo" />
							</>
						)}

						<Text.Title28 fontWeight="bold" mb={{ mobile: 'xxs', tablet: 's' }}>
							{item.title}
						</Text.Title28>
						{item.desc && <Text.Body16 color="textSecondary">{item.desc}</Text.Body16>}
					</Box>
				))}
			</StyledCarousel>
			<Box my="m">
				<Flex justifyContent="center" alignItems="center">
					<ArrowButton
						onClick={() => carousel.slickPrev()}
						disabled={currentSlideInfo.slideNumber - 1 === 0}
						aria-label="previous slide"
						data-testid="previous slide"
					>
						<ChevronLeftIcon size="1.5rem" />
					</ArrowButton>
					<Dots data-testid="dots">
						{slides.map((e, index) => (
							<li
								key={index}
								className={currentSlideInfo.slideNumber - 1 === index ? 'active' : ''}
								data-testid="dot"
							>
								<button onClick={() => carousel.slickGoTo(index)}>
									{`Slide ${index + 1}`}
								</button>
							</li>
						))}
					</Dots>
					<ArrowButton
						onClick={() => carousel.slickNext()}
						disabled={currentSlideInfo.slideNumber === slides.length}
						aria-label="next slide"
						data-testid="next slide"
					>
						<ChevronRightIcon size="1.25rem" />
					</ArrowButton>
				</Flex>
			</Box>
		</>
	);
};

Carousel.propTypes = {
	slides: PropTypes.arrayOf(
		PropTypes.shape({
			img: PropTypes.string.isRequired,
			mobileImg: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			desc: PropTypes.string,
			slideName: PropTypes.string.isRequired,
		})
	).isRequired,
	sendSlideInfo: PropTypes.func,
	currentSlideInfo: PropTypes.shape({
		slideName: PropTypes.string.isRequired,
		slideNumber: PropTypes.number,
	}),
};

export default Carousel;
